import React from 'react';
import { useMediaQuery } from 'usehooks-ts';
import style from './PlanServicePlanHighlight.module.scss';
import ScrollFixedImages from './ScrollFixedImages/PlanScrollFixedImages';

const ServicePlanHighlight = ({ data }) => {
  const isTablet = useMediaQuery('(max-width: 834px)');
  const isMobile = useMediaQuery('(max-width: 480px)');

  const getImageUrl = (imageField) => {
    if (!imageField?.fields) return '';

    const getImageUrlFromField = (field) => {
      if (!field?.value?.src) return '';
      return field.value.src;
    };

    if (isMobile) {
      return (
        getImageUrlFromField(imageField.fields.mobileImage) ||
        getImageUrlFromField(imageField.fields.tabletImage) ||
        getImageUrlFromField(imageField.fields.desktopImage) ||
        ''
      );
    }

    if (isTablet) {
      return (
        getImageUrlFromField(imageField.fields.tabletImage) ||
        getImageUrlFromField(imageField.fields.desktopImage) ||
        ''
      );
    }

    return getImageUrlFromField(imageField.fields.desktopImage) || '';
  };

  const title = data?.title?.value || data?.title || 'Service Plan Benefits';
  const imageItems = data?.imageItems || [];

  if (!imageItems || imageItems.length === 0) {
    return null;
  }

  // 转换为ScrollFixedImages需要的格式
  const transformImageData = (items, isMobile = false) => {
    return items.map((item, index) => {
      const itemFields = item?.fields || item;
      const imageUrl = getImageUrl(itemFields?.image);
      const itemTitle = itemFields?.title?.value || '';
      const imageText = itemFields?.imageText?.value || '';
      const imageDescription = itemFields?.imageDescription?.value || '';

      return {
        id: index + 1,
        title: itemTitle,
        text: imageText,
        image: {
          url: imageUrl,
          alternativeText: itemTitle,
        },
      };
    });
  };

  const desktopData = transformImageData(imageItems, false);
  const mobileData = transformImageData(imageItems, true);

  return (
    <section className={style.servicePlanHighlight}>
      <h2 className={style.title} data-aos="fade-up">
        {title}
      </h2>
      <div className={style.desktop}>
        <ScrollFixedImages dataImage={desktopData} />
      </div>
      <div className={style.mobile}>
        <ScrollFixedImages dataImage={mobileData} />
      </div>
    </section>
  );
};

export default ServicePlanHighlight;
